import React from "react";
import "../css/About.css";

const About = () => {
  return (
    <div className="about">
      <p>
        Welcome to Gloucester Road Pharmacy, formerly known as Sood
        Chemist. Our pharmacy has built a reputation for exceptional care,
        reliability, and personalised service. We are committed to meet the needs of our valued customers
        by offering a wide range of health and tailored wellness solutions
        tailored. Whether you’re seeking advice, prescriptions, or healthcare essentials,
        we are here to support you every step of the way.
      </p>
    </div>
  );
};

export default About;
